<div class="modal fade" id="{{modalId}}" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div *ngIf="pageLoading1" class="loader text-center">
				<img src="../../assets/img/loading.gif" />
				<p style="color: black;font-weight: bolder;">Loading...</p>
			</div>
			<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
				<div class="modal-header text-center row g-1">
					<h4 class="modal-title mb-0 col-11 text-start">
						<strong>
							{{uId ? "Edit Regularization" : "Add Regularization"}}
						</strong>
					</h4>
					<div class="col-1 text-end">
						<button type="button" class="btn-close" (click)="clearForm();"></button>
					</div>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<div class="row mb-3">
								<div class="col-6">
									<div class="ng-select-material">
										<ng-select [items]="userList" bindValue="emp_code" bindLabel="full_name"
											[clearable]="true" placeholder="Employee*" formControlName="emp_code"
											id="emp_code_reg" appearance="outline"
											[ngClass]="{'is-invalid':showError('emp_code')}">
										</ng-select>
									</div>
									<p *ngIf="showError('emp_code')" class="text-danger">
										<span *ngIf="f.emp_code.errors?.required">
											Required
										</span>
										<span *ngIf="f.emp_code.errors?.incorrect">
											{{customError.emp_code}}
										</span>
									</p>
								</div>
								@if(navbar.hasRegularizationAccess()){
								<div class="col-6">
									@if (!isAssignee) {
									<mat-checkbox [color]="'primary'" formControlName="is_approved" id="is_approved_reg"
										class="me-2">
										Approved
									</mat-checkbox>
									}
									<mat-checkbox [color]="'primary'" formControlName="weekly_off" id="weekly_off_reg"
										(change)="changedWeeklyOf_or_WorkFromHome('wo')" class="me-2">
										Weekly Off
									</mat-checkbox>
									<mat-checkbox [color]="'primary'" formControlName="wfh" id="work_from_home_reg"
										(change)="changedWeeklyOf_or_WorkFromHome('wfh')">
										Work From Home
									</mat-checkbox>
								</div>
								}
							</div>
							<div class="row mb-3">
								<div class="col-2">
									<label class="control-label">Date*</label>
									<div class="input-group">
										<input class="form-control" [ngClass]="{'is-invalid':showError('date')}"
											placeholder="YYYY-MM-DD" formControlName="date" ngbDatepicker id="date_reg"
											#date="ngbDatepicker" [minDate]="minDate" [container]="'body'" />
										<button class="btn btn-outline-secondary" (click)="date.toggle()" type="button">
											<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
										</button>
									</div>
									<p *ngIf="showError('date')" class="text-danger">
										<span *ngIf="f.date.errors?.required">
											Required
										</span>
										<span *ngIf="f.date.errors?.ngbDate">
											Invalid
										</span>
										<span *ngIf="f.date.errors?.incorrect">
											{{customError.date}}
										</span>
									</p>
								</div>
								<div class="col-4">
									<div class="w-50 float-start">
										<label class="control-label">
											In Date Time
											<span *ngIf="isRequired('in_date') || isRequired('in_time')">*</span>
										</label>
										<div class="input-group">
											<input class="form-control" [ngClass]="{'is-invalid':showError('in_date')}"
												placeholder="YYYY-MM-DD" formControlName="in_date" ngbDatepicker
												id="in_date_reg" #in_date="ngbDatepicker" [minDate]="minDate"
												[container]="'body'" />
											<button class="btn btn-outline-secondary" (click)="in_date.toggle()"
												type="button">
												<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
											</button>
										</div>
										<p *ngIf="showError('in_date')" class="text-danger">
											<span *ngIf="f.in_date.errors?.required">
												Required
											</span>
											<span *ngIf="f.in_date.errors?.ngbDate">
												Invalid
											</span>
											<span *ngIf="f.in_date.errors?.incorrect">
												{{customError.in_date}}
											</span>
										</p>
									</div>
									<div class="w-50 float-start ps-1">
										<br />
										<div>
											<ngb-timepicker formControlName="in_time" [hourStep]="1" [minuteStep]="1"
												[meridian]="false" [spinners]="false"></ngb-timepicker>
										</div>
										<p *ngIf="showError('in_time')" class="text-danger">
											<span *ngIf="f.in_time.errors?.required">
												Required
											</span>
										</p>
									</div>
								</div>
								<div class="col-4">
									<div class="w-50 float-start">
										<label class="control-label">
											Out Date Time
											<span *ngIf="isRequired('out_date') || isRequired('out_time')">*</span>
										</label>
										<div class="input-group">
											<input class="form-control" [ngClass]="{'is-invalid':showError('out_date')}"
												placeholder="YYYY-MM-DD" formControlName="out_date" ngbDatepicker
												id="out_date_reg" #out_date="ngbDatepicker" [minDate]="minDate"
												[container]="'body'" />
											<button class="btn btn-outline-secondary" (click)="out_date.toggle()"
												type="button">
												<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
											</button>
										</div>
										<p *ngIf="showError('out_date')" class="text-danger">
											<span *ngIf="f.out_date.errors?.required">
												Required
											</span>
											<span *ngIf="f.out_date.errors?.ngbDate">
												Invalid
											</span>
											<span *ngIf="f.out_date.errors?.incorrect">
												{{customError.out_date}}
											</span>
										</p>
									</div>
									<div class="w-50 float-start ps-1">
										<br />
										<div>
											<ngb-timepicker formControlName="out_time" [hourStep]="1" [minuteStep]="1"
												[meridian]="false" [spinners]="false"></ngb-timepicker>
										</div>
										<p *ngIf="showError('out_time')" class="text-danger">
											<span *ngIf="f.out_time.errors?.required">
												Required
											</span>
										</p>
									</div>
								</div>
								<div class="col-2">
									<label class="control-label">
										Work Time
										<span *ngIf="isRequired('work_time')">*</span>
									</label>
									<div>
										<ngb-timepicker formControlName="work_time" [hourStep]="1" [minuteStep]="1"
											[meridian]="false" [spinners]="false"></ngb-timepicker>
									</div>
									<p *ngIf="showError('work_time')" class="text-danger">
										<span *ngIf="f.work_time.errors?.required">
											Required
										</span>
									</p>
								</div>
							</div>
							<div class="row mb-3">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<div class="form-floating">
										<input class="form-control" [ngClass]="{'is-invalid':showError('reason')}"
											id="reason_reg" formControlName="reason" placeholder="">
										<label>
											Reason
											<span *ngIf="isRequired('reason')">*</span>
										</label>
									</div>
									<p *ngIf="showError('reason')" class="text-danger">
										<span *ngIf="f.reason.errors?.required">
											Required
										</span>
										<span *ngIf="f.reason.errors?.incorrect">
											{{customError.reason}}
										</span>
									</p>
								</div>
							</div>
							<div class="row mb-3">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<button type="submit" class="btn btn-sm btn-primary me-1">
										<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
										<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
										Submit
									</button>
									<button type="button" class="btn btn-sm btn-secondary"
										(click)="clearForm();">Cancel</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>